import api from "api";

const PATH = "/Questao";
const qs = require("qs");

const SAVE_QUESTAO = async (questao) => {
  try {
    const formData = new FormData();
    formData.append("questaoId", questao.questaoId);
    formData.append("enunciado", questao.enunciado);
    formData.append("resolucao", questao.resolucao);
    formData.append("dificuldade", questao.dificuldade);
    formData.append("urlImagemEnunciado", questao.urlImagemEnunciado);
    formData.append("urlImagemResolucao", questao.urlImagemResolucao);

    questao.categoriaId.forEach((categoriaId) => {
      formData.append("categorias[]", categoriaId);
    });

    if (questao.imagemEnunciado) {
      formData.append("imagemEnunciado", questao.imagemEnunciado);
    }

    if (questao.imagemResolucao) {
      formData.append("imagemResolucao", questao.imagemResolucao);
    }

    questao.respostas.forEach((resposta, index) => {
      formData.append(`respostas[${index}].respostaId`, resposta.respostaId);
      formData.append(`respostas[${index}].texto`, resposta.texto);
      formData.append(`respostas[${index}].correto`, resposta.correto);
      formData.append(`respostas[${index}].urlImagem`, resposta.urlImagem);
      formData.append(`respostas[${index}].questaoId`, resposta.questaoId);
      if (resposta.imagem) {
        formData.append(`respostas[${index}].imagem`, resposta.imagem);
      }
    });

    const { data } = await api.post(`${PATH}/save`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    if (error.response && error.response.data) {
      console.error("Response data:", error.response.data);
    } else {
      console.error(error);
    }
    return undefined;
  }
};

const GET_LIST_QUESTAO_FILTRO = async (filtros) => {
  try {
    const { data } = await api.get(`${PATH}/get-list-paged`, {
      params: filtros,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};
const GET_LIST_QUESTAO_PARCIAL = async (filtros) => {
  try {
    const { data } = await api.get(`${PATH}/get-list-questao-parcial`, {
      params: filtros,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_QUESTAO_ID = async (id) => {
  try {
    const { data } = await api.get(`${PATH}/get-questao/${id}`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const DELETE_QUESTAO = async (id) => {
  try {
    const { data } = await api.post(`${PATH}/delete/${id}`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const PRE_SAVE_QUESTAO = async (questao) => {
  try {
    const formData = new FormData();
    formData.append("questaoId", questao.questaoId);
    formData.append("enunciado", questao.enunciado);
    formData.append("resolucao", questao.resolucao);
    formData.append("dificuldade", questao.dificuldade);
    formData.append("urlImagemEnunciado", questao.urlImagemEnunciado);
    formData.append("urlImagemResolucao", questao.urlImagemResolucao);

    questao.categoriaId.forEach((categoriaId) => {
      formData.append("categorias[]", categoriaId);
    });

    if (questao.imagemEnunciado) {
      formData.append("imagemEnunciado", questao.imagemEnunciado);
    }

    if (questao.imagemResolucao) {
      formData.append("imagemResolucao", questao.imagemResolucao);
    }

    questao.respostas.forEach((resposta, index) => {
      formData.append(`respostas[${index}].respostaId`, resposta.respostaId);
      formData.append(`respostas[${index}].texto`, resposta.texto);
      formData.append(`respostas[${index}].correto`, resposta.correto);
      formData.append(`respostas[${index}].urlImagem`, resposta.urlImagem);
      formData.append(`respostas[${index}].questaoId`, resposta.questaoId);
      if (resposta.imagem) {
        formData.append(`respostas[${index}].imagem`, resposta.imagem);
      }
    });

    const { data } = await api.post(`${PATH}/pre-saLvar-questao`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    if (error.response && error.response.data) {
      console.error("Response data:", error.response.data);
    } else {
      console.error(error);
    }
    return undefined;
  }
};

const SAVE_QUESTAO_TEXT_EDITOR = async (questao) => {
  try {
    const formData = new FormData();
    formData.append("questaoId", questao.questaoId);
    formData.append("enunciado", questao.enunciado);
    formData.append("resolucao", questao.resolucao);
    formData.append("dificuldade", questao.dificuldade);
    formData.append("urlImagemEnunciado", questao.urlImagemEnunciado);
    formData.append("urlImagemResolucao", questao.urlImagemResolucao);

    questao.categoriaId.forEach((categoriaId) => {
      formData.append("categorias[]", categoriaId);
    });

    if (questao.imagemEnunciado) {
      formData.append("imagemEnunciado", questao.imagemEnunciado);
    }

    if (questao.imagemResolucao) {
      formData.append("imagemResolucao", questao.imagemResolucao);
    }

    questao.respostas.forEach((resposta, index) => {
      formData.append(`respostas[${index}].respostaId`, resposta.respostaId);
      formData.append(`respostas[${index}].texto`, resposta.texto);
      formData.append(`respostas[${index}].correto`, resposta.correto);
      formData.append(`respostas[${index}].urlImagem`, resposta.urlImagem);
      formData.append(`respostas[${index}].questaoId`, resposta.questaoId);
      if (resposta.imagem) {
        formData.append(`respostas[${index}].imagem`, resposta.imagem);
      }
    });

    const { data } = await api.post(`${PATH}/salvar-questao`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    if (error.response && error.response.data) {
      console.error("Response data:", error.response.data);
    } else {
      console.error(error);
    }
    return undefined;
  }
};

const UPLOAD_IMAGEM = async (formData) => {
  try {
    const { data } = await api.post(`${PATH}/upload-imagem`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export {
  DELETE_QUESTAO,
  GET_LIST_QUESTAO_FILTRO,
  GET_LIST_QUESTAO_PARCIAL,
  GET_QUESTAO_ID,
  SAVE_QUESTAO,
  PRE_SAVE_QUESTAO,
  UPLOAD_IMAGEM,
  SAVE_QUESTAO_TEXT_EDITOR,
};
